import { render } from "./footnotes.vue?vue&type=template&id=1a724812"
import script from "./footnotes.vue?vue&type=script&lang=js"
export * from "./footnotes.vue?vue&type=script&lang=js"

import "./footnotes.vue?vue&type=style&index=0&id=1a724812&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__